module.exports = __webpack_public_path__ + "static/media/chat09.6475da1d.svg";